// A grammar term's example sentences in its card (Axel 2026-10-21): Peterson's own sentences from the bundle
// (./examples.data.ts), the concept's words marked, then the official English and the Finnish with its badge,
// as a lesson's <Example> shows them. Nothing while the dictionary is loading or when the term has none.
import { Hv } from '../../components/Hv';
import { useT } from '../../i18n';
import { useApp } from '../../state/store';
import { markedPieces, TERM_EXAMPLES } from './examples.data';

export function TermExamples({ id }: { id: string }) {
  const t = useT();
  const dict = useApp((s) => s.dict);
  const list = TERM_EXAMPLES[id];
  if (!list?.length || !dict) return null;
  const rows = list.flatMap((x) => {
    const ex = dict.examples.get(x.ex);
    return ex ? [{ ex, mark: x.mark }] : [];
  });
  if (!rows.length) return null;
  return (
    <div className="term-card-examples">
      <p className="term-card-l">{t.grammarTerms.examples}</p>
      {rows.map(({ ex, mark }) => (
        <figure key={ex.id} className="term-ex" data-term-example={ex.id}>
          <Hv as="blockquote" className="term-ex-hv">
            {markedPieces(ex.hv, mark).map((p, i) =>
              p.marked ? (
                <mark key={i} className="term-ex-mark">
                  {p.text}
                </mark>
              ) : (
                p.text
              ),
            )}
          </Hv>
          <figcaption>
            <span className="term-ex-tr" lang="en">
              {ex.en}
            </span>
            {ex.fi ? (
              <span className="term-ex-tr">
                <span lang="fi">{ex.fi}</span>
              </span>
            ) : null}
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
